import { Button, Icon } from '@ss/mtd-react3';
import { PureComponent } from 'react';
import './style.scss';
import { currentInitConfig } from '../../utils/init';
import KEETA from "@/assets/images/Keeta Brand Assets new.svg";
import PropTypes from 'prop-types';

class LoginInternal extends PureComponent {
    constructor(props) {
        super(props);
    }

    componentDidMount() {

    }

    componentWillUnmount() {

    }

    jumpToInner = () => {
        const { brandConfig } = currentInitConfig();
        const { appendPath } = this.props;
        window.open(`${brandConfig.host.innerHost}${brandConfig.basePath.innerBasePath}${appendPath}`);
    }


    render() {
        return (
            <div className="login-internal">
                <div className="login-internal-wrapper">
                    <div className="login-internal-wrapper-logo">
                        <img src={KEETA} alt="logo" className="login-internal-wrapper-logo-img"/>
                    </div>
                    <div className="login-internal-wrapper-content">
                        <div className="login-internal-wrapper-content-message">
                            Sorry,  you don't have access. If you are an external partner,  please contact your business partner to obtain an account.
                        </div>
                        <div className="login-internal-wrapper-content-button">
                            <Button type="primary" onClick={this.jumpToInner} style={{width: '372px',height: '40px',fontSize: '16px',fontWeight: 500 }}>Sign in via SSO
                                <Icon type="arrow-right" style={{marginLeft: '5px',fontSize: '16px',fontWeight: 500}}/>
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

LoginInternal.defaultProps = {
    appendPath: '/'
};

LoginInternal.propTypes = {
    appendPath: PropTypes.string.isRequired
};

export default LoginInternal;
